import React from 'react';
import './Notification.css';

const Notification = ({ message, type }) => (
  <div className={`profile-notification ${type}`}>
    {message}
  </div>
);

export default Notification;